import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { FlexLayoutModule } from '@angular/flex-layout';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import {
  MatButtonModule,
  MatInputModule,
  MatIconModule,
  MatSidenavModule,
  MatTableModule,
  MatToolbarModule,
  MatCardModule,
  MatFormFieldModule,
  MatListModule,
} from '@angular/material'
import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { 
  RouterModule,
  Routes
} from '@angular/router';

import { LandingPageModule } from '../landing-page/landing-page.module';
import { SitesModule } from '../sites/sites.module';
import { ProductsModule } from '../products/products.module';

import { AppComponent } from './app.component';
import { SitesService } from '../services/sites.service';
import { SocketService } from '../services/socket.service';
import { ComponentsModule } from '../components/components.module'
import { UploadService } from '../services/upload.service';


import { appRoutes } from './routes';


@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    RouterModule.forRoot(
      appRoutes,
      {
        useHash: true
      }
    ),
    BrowserModule,
    LoadingBarHttpClientModule,
    ComponentsModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MatIconModule,
    MatCardModule,
    MatButtonModule,
    MatSidenavModule,
    MatInputModule,
    MatTableModule,
    MatToolbarModule,
    MatFormFieldModule,
    MatListModule,
    LandingPageModule,
    LeafletModule.forRoot(),
    FlexLayoutModule,
    SitesModule,
    ProductsModule,
  ],
  providers: [
    SitesService,
    SocketService,
    UploadService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
